function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Pause");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.7,0H0.3A0.3,0.3,0,0,0,0,.3V23.7a0.3,0.3,0,0,0,.3.3H5.7A0.3,0.3,0,0,0,6,23.7V0.3A0.3,0.3,0,0,0,5.7,0Zm10,0H10.3a0.3,0.3,0,0,0-.3.3V23.7a0.3,0.3,0,0,0,.3.3h5.4a0.3,0.3,0,0,0,.3-0.3V0.3A0.3,0.3,0,0,0,15.7,0Z"
});

var SvgPause = function SvgPause(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 16 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPause, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pause.e3234a64.svg";
export { ForwardRef as ReactComponent };